import { render } from "./CometChatReceiverStickerMessageBubble.vue?vue&type=template&id=22028224"
import script from "./CometChatReceiverStickerMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatReceiverStickerMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatReceiverStickerMessageBubble.vue?vue&type=style&index=0&id=22028224&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__